import jerseyDesigns from "./jerseyDesigns";

const endpoints = {
    BOOTSTRAP_STATIC: "https://fantasy.premierleague.com/api/bootstrap-static/"
}

const constants = {
    endpoints,
    jerseyDesigns
}

export default constants;